import { Avatar, Grid } from "@material-ui/core";
import { Box, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  REACT_CREATE_KEY_CONFIGURATION,
  REACT_VIEW_KEY_CONFIGURATION,
} from "../../actions/EndPoints";
import "../../App.css";
import CreateKeyConfurationIcon from "../../assets/USA_Images/createKeyConfiguration.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import ResetKeyAssignmentDialog from "../../components/DialogBoxComponent/ResetKeyAssignmentDialog";
import HeaderToolbar from "../../components/HeaderToolbar";
import EditIcon from "../../Pages/Person/EditIcon";
import { getMobileConfigurations } from "../../slices/MobileKeyConfiguration/MobileKeyConfigurationSlice";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import ViewIcon from "../Invitations/ViewIcon";
import KeyAssignmentDeleteIcon from "../KeyConfiguration/KeyAssignmentDeleteIcon";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";

export default function KeyConfiguration() {
  const history = useHistory();
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [searchRecord, setSearchRecord] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [searchedRows, setSerchedRows] = useState([]);
  const [openEditUser, setOpenEditUser] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [country, setCountry] = useState("");
  const [openResetKeyAssignment, setOpenResetKeyAssignment] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [customerName, setCustomerName] = useState();
  const [numberOfDevices, setNumberOfDevices] = useState();

  const handleOpen = () => {
    setOpen(true);
    history.push({
      pathname: REACT_CREATE_KEY_CONFIGURATION,
      country: country,
    });
  };

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const handleView = (params) => {
    history.push({
      pathname: REACT_VIEW_KEY_CONFIGURATION,
      state: params,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadConfigurations(paging);
  }, [paging]);

  const loadConfigurations = (paging) => {
    dispatch(getMobileConfigurations(Object.assign(paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4028" && !CommonUtil.isEmpty(data.data)) {
          setRows(data.data.MobilekeyConfigurations);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      });
  };

  const handleEditMobileKeyConfiguration = (params) => {
    history.push({
      pathname: REACT_CREATE_KEY_CONFIGURATION,
      state: {
        params: params,
      },
    });
  };

  const ZoomHandaler = (params) => (
    <SimpleDialogDemo
      button={
        <Avatar
          style={{
            cursor: "pointer",
          }}
          alt={params.row.firstName}
          src={
            params.row.imagePreSignedURL !== undefined
              ? params.row.imagePreSignedURL
              : null
          }
        ></Avatar>
      }
      child={
        <Avatar
          style={{
            width: "300px",
            height: "300px",
            border: "1px solid #FFFF",
            fontSize: "100px",
            borderRadius: "50%",
            cursor: "pointer",
          }}
          alt={params.row.firstName}
          src={params.row.imagePreSignedURL}
        ></Avatar>
      }
    />
  );

  const handleResetKeyAssignment = (params) => {
    setOpenResetKeyAssignment(!openResetKeyAssignment);
    setCustomerId(params.customerId);
    setCustomerName(params.customerName);
    setNumberOfDevices(params.numberOfDevices);
  };

  const columns = React.useMemo(() => [
    {
      field: "company.profile",
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },
    {
      field: "name",
      headerName: t("CUSTDATABLE26"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.customerName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "iosKey",
      headerName: t("CUSTDATABLE31"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.pdfDetectorActivationKey,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "androidKey",
      headerName: t("CUSTDATABLE32"),
      type: "singleSelect",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.privateConstValParserKey,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "numberOfDevice",
      headerName: t("CUSTDATABLE33"),
      flex: 1,
      valueGetter: (params) => params.row.numberOfDevices,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },
    {
      field: "Actions",
      headerName: t("CUSTDATABLE16"),
      type: "actions",
      flex: 1,
      minWidth: 150,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => handleEditMobileKeyConfiguration(params.row)}
        />,
        <GridActionsCellItem
          icon={<ViewIcon />}
          label="View"
          onClick={() => handleView(params.row)}
        />,

        <GridActionsCellItem
          icon={<KeyAssignmentDeleteIcon />}
          label={t("DELETE")}
          onClick={() => handleResetKeyAssignment(params.row)}
        />,
      ],
    },
  ]);

  return (
    <>
      <HeaderToolbar title={t("KEYCONFIGURATIONHEADER")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Tooltip title={t("LABELNAVITEMSCREATEKEY")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
      </Box>

      <Grid item style={{ width: "100%", height: 300 }}>
        <DataTableLatest
          columns={columns}
          rows={searchedRows.length === 0 ? rows : searchedRows}
          page={page}
          pageCount={totalPages}
          count={totalRecords}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </Grid>
      {openResetKeyAssignment && (
        <ResetKeyAssignmentDialog
          open={openResetKeyAssignment}
          handleDialogClose={handleClose}
          loadData={() => {
            loadConfigurations(paging);
          }}
          handleClose={(data) => {
            setOpenResetKeyAssignment(data);
          }}
          customerId={customerId}
          customerName={customerName}
          numberOfDevices={numberOfDevices}
        />
      )}
    </>
  );
}
